(() => {
  const closeAll = (except = null) => {
    document.querySelectorAll('.hv-nav__item.is-open').forEach((item) => {
      if (item === except) return;
      item.classList.remove('is-open');
      item.querySelector(':scope > .hv-nav__toggle')?.setAttribute('aria-expanded', 'false');
    });
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('.hv-nav__toggle');
    if (toggle) {
      event.preventDefault();
      event.stopPropagation();
      const item = toggle.closest('.hv-nav__item');
      const opening = !item.classList.contains('is-open');
      closeAll(item);
      item.classList.toggle('is-open', opening);
      toggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
      return;
    }
    if (!event.target.closest('.hv-nav')) closeAll();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeAll();
      document.querySelector('.hv-nav__toggle:focus')?.blur();
    }
  });
})();
